import { Modal, message } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getFundChangeList, submitFundChange } from "../../../API/wallet";
import { getUserInfo } from "../../../API";
import { useSelector } from "react-redux";
import Pagination from "../../../components/Pagination";
import ProductProfit from "./productProfit"

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = React.useState(1);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [amount, setAmount] = React.useState("");
  const [userRemark, setUserRemark] = React.useState("");
  const [withdrawMethod, setWithdrawMethod] = React.useState("BANK_TRANSFER");
  const [accountNumber, setAccountNumber] = React.useState("")
  const [password, setPassword] = React.useState("")
  const handleSubmit = () => {
    submitFundChange({
      "phone": userInfo?.phone,
      "amount": amount,
      "type": 'WITHDRAW',
      "userRemark": userRemark,
      "withdrawMethod": withdrawMethod,
      "accountNumber": accountNumber,
      password: btoa((password || '').trim())
    }).then((res) => {
      message.success('提交成功')
      handleUserInfo();
      handleWalletLi();
      handleCloseModal();
      setAmount('');
      setUserRemark('');
      setWithdrawMethod('BANK_TRANSFER');
      setAccountNumber('');
      setPassword(''); 
    }).catch((err) => {
      // console.log(err);
    });
  };

  const [userInfo, setUserInfo]: any = React.useState({});
  const handleUserInfo = () => {
    getUserInfo().then((res) => {
      setUserInfo(res.data);
    }).catch((err) => {
    });
  }

  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!!token) {
      handleUserInfo();
      handleWalletLi();
    }
  }, [token, tabIndex]);

  const [totalPages, setTotalPages] = React.useState(0)
  const [pageNum, setPageNum] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(20)
  const [walletLi, setWalletLi] = React.useState<any>([]);
  const handleWalletLi = () => {
    getFundChangeList({
      pageNum: pageNum,
      pageSize: pageSize,
      params: {
        type: tabIndex === 1 ? null : tabIndex === 2 ? 'DEPOSIT' : 'WITHDRAW'
      }
    }).then((res) => {
      setTotalPages(res.data?.totalPages || 0);
      setWalletLi(res.data?.records);
    }).catch((err) => {
    });
  }

  return (
    <div className="">
      <div className="bg-[#f6f5f1] px-[20px] py-[26px] rounded-md  mb-[30px]">
        <div className="text-[#181512] text-[20px] font-bold">{userInfo?.balance || 0}</div>
        <div className="text-[#595959] text-[14px]">總餘額（USD$）</div>
      </div>
      <div className="flex items-center mb-[20px]">
        <div className="inline-block px-[20px] py-[6px] text-[#fff] bg-[#181512] rounded-md cursor-pointer"
          onClick={() => {
            message.success('請聯繫客服人員進行人工存款')
          }}
          style={{
            border: '1px solid #181512'
          }}>存款</div>
        <div className="inline-block px-[20px] py-[6px] text-[#181512] rounded-md ml-20 cursor-pointer"
          onClick={() => {
            setIsModalOpen(true);
          }}
          style={{
            border: '1px solid #181512'
          }}>提款</div>
      </div>
      <div className="flex items-center mb-20">
        <div className="inline-block px-[20px] py-[6px] text-[#181512] rounded-md cursor-pointer"
          style={{
            color: tabIndex === 1 ? '#181512' : '#595959',
            fontWeight: tabIndex === 1 ? 'bold' : 'normal',
          }}
          onClick={() => {
            setTabIndex(1)
          }} >全部</div>
        <div className="inline-block px-[20px] py-[6px] text-[#181512] rounded-md cursor-pointer mx-20"
          style={{
            color: tabIndex === 2 ? '#181512' : '#595959',
            fontWeight: tabIndex === 2 ? 'bold' : 'normal',
          }}
          onClick={() => {
            setTabIndex(2)
          }} >存款</div>
        <div className="inline-block px-[20px] py-[6px] text-[#181512] rounded-md cursor-pointer"
          style={{
            color: tabIndex === 3 ? '#181512' : '#595959',
            fontWeight: tabIndex === 3 ? 'bold' : 'normal',
          }}
          onClick={() => {
            setTabIndex(3)
          }} >提款</div>
      </div> 
      <div className={`${tabIndex === 4 ? 'hidden' : 'block'}`}> 
        {
          walletLi && walletLi.map((item: any, index: number) => (
            <div className="rounded-md px-[16px] py-[20px] mb-[16px]"
              key={index}
              style={{
                boxShadow: "0 1px 5px rgba(0, 0, 0, .1)"
              }}>
              <div className="flex items-center">
                <div className="flex-1 text-[#181512] text-[16px]">
                  {/* {item?.type === 'DEPOSIT' ? '存款' : '提款'} */}
                  {item?.typeDesc}
                </div>
                <div className=" text-[18px] font-bold"
                  style={{
                    color: item?.type === 'DEPOSIT' ? '#46c91b' : 'red'
                  }}
                >
                  {item?.type === 'DEPOSIT' ? '+' : '-'}
                  {item?.amount}
                </div>
              </div>
              <div className="flex items-center mb-10 pt-6 pb-8"
                style={{
                  borderBottom: '1px solid #e0e0e0'
                }}>
                <div className="flex-1 text-[#595959] text-[13px]">{item?.createTime}</div>
                <div className="text-[#595959] text-[13px]">
                  {item?.statusDesc}
                  {/* {item?.status === 'SUBMITTED' ? '已提交' : item?.status === 'APPROVED' ? '審核中' : item?.status === 'REJECTED' ? '已拒絕' : '已取消'} */}
                </div>
              </div>
              <div className=" text-[#595959] text-[13px]">備註：{item?.userRemark}</div>
            </div>
          ))
        }
      </div>
      <div className="flex justify-center pb-[75px]">
        {
          Math.ceil(totalPages / pageSize) > 1 ?
            <Pagination
              totalPages={Math.ceil(totalPages / pageSize)}
              currentPage={pageNum}
              onPageChange={(page: number) => setPageNum(page)}
            /> :
            ''
        }
      </div>

      <Modal
        title={`提款`}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        onCancel={() => {
          handleCloseModal();
        }}
      >
        <div>
          <div className="flex items-center pb-10 pt-20"
            style={{
              borderBottom: '1px solid #e0e0e0'
            }}>
            <div className="text-[#181512] text-[16px]">提款金額</div>
            <input type="number"
              value={amount}
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              className="w-[206px] text-[#000] text-[16px] px-16 focus-visible:outline-none"
              placeholder="請輸入提款金額" />
          </div>
          <div className="flex items-center pb-10 pt-20">
            <div className="text-[#181512] text-[16px]">提款方式</div>
          </div>
          <div className="flex items-center pb-20"
            style={{
              borderBottom: '1px solid #e0e0e0'
            }}>
            <div className="flex-1 text-[#181512] text-[16px] flex items-center"
              onClick={() => setWithdrawMethod('BANK_TRANSFER')}>
              <img src={withdrawMethod === 'BANK_TRANSFER' ?
                require("../../../assets/image/select.png")
                : require("../../../assets/image/select1.png")}
                className="w-[22px] h-[22px] mr-4" alt="" />
              銀行匯款
            </div>
            <div className="flex-1 text-[#181512] text-[16px] flex items-center"
              onClick={() => setWithdrawMethod('DIGITAL_CURRENCY')}>
              <img src={withdrawMethod === 'DIGITAL_CURRENCY' ?
                require("../../../assets/image/select.png")
                : require("../../../assets/image/select1.png")}
                className="w-[22px] h-[22px] mr-4" alt="" />
              數位美金
            </div>
          </div>
          <div className="pb-10 pt-20"
            style={{
              borderBottom: '1px solid #e0e0e0'
            }}>
            <div className="text-[#181512] text-[16px] pb-10">收款賬號</div>
            <input type="text"
              value={accountNumber}
              onChange={(e) => {
                setAccountNumber(e.target.value);
              }}
              className="w-[206px] text-[#000] text-[16px] pr-16 focus-visible:outline-none"
              placeholder="請輸入收款賬號" />
          </div>
          <div className="flex items-center pb-10 pt-20"
            style={{
              borderBottom: '1px solid #e0e0e0'
            }}>
            <div className="text-[#181512] text-[16px]">支付密碼</div>
            <input type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className="w-[206px] text-[#000] text-[16px] px-16 focus-visible:outline-none"
              placeholder="請輸入支付密碼" />
          </div>
          <div className="pb-10 pt-20"
            style={{
              borderBottom: '1px solid #e0e0e0'
            }}>
            <div className="text-[#181512] text-[16px] pb-10">備註</div>
            <input type="text"
              value={userRemark}
              onChange={(e) => {
                setUserRemark(e.target.value);
              }}
              className="w-[206px] text-[#000] text-[16px] pr-16 focus-visible:outline-none"
              placeholder="請輸入備註" />
          </div>
          <div className="flex justify-center mt-[30px]">
            <div
              onClick={() => {
                handleSubmit()
              }}
              className="bg-[#000] rounded-[14px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    ">
              確認提款
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ComponentName;
